/**
 * UUID Generation Command
 * Generate UUID v4 identifiers
 */
import { Command } from 'commander';
import { UtilsService } from '../../services/utils.service.js';

async function handleUuidGeneration(options: {
    count: number;
    uppercase: boolean;
    noHyphens: boolean;
}): Promise<void> {
    const service = new UtilsService();

    try {
        const uuids: string[] = [];

        for (let i = 0; i < options.count; i++) {
            const uuid = service.generateUuid({
                uppercase: options.uppercase,
                noHyphens: options.noHyphens,
            });
            uuids.push(uuid);
        }

        console.log('🆔 Generated UUID(s):');
        console.log('────────────────────────────────────────\n');

        uuids.forEach((uuid, index) => {
            if (options.count > 1) {
                console.log(`   ${index + 1}. ${uuid}`);
            } else {
                console.log(`   ${uuid}`);
            }
        });

        console.log();
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

export function createUuidCommand(): Command {
    const cmd = new Command('uuid')
        .description('Generate UUID v4 identifier')
        .option('-c, --count <number>', 'Number of UUIDs to generate', '1')
        .option('--uppercase', 'Output in uppercase')
        .option('--no-hyphens', 'Remove hyphens from output')
        .addHelpText('after', `
Examples:
  $ jai1 utils uuid
  $ jai1 utils uuid --count 10
  $ jai1 utils uuid --uppercase
  $ jai1 utils uuid --no-hyphens
  $ jai1 utils uuid --uppercase --no-hyphens
`)
        .action(async (options) => {
            await handleUuidGeneration({
                ...options,
                count: parseInt(options.count, 10),
            });
        });

    return cmd;
}
